import React from "react";
import styled from "styled-components";
import Icon from "./icon";

const Container = styled.div`
  font-size: 16px;
  display: flex;
  align-items: center;

  span {
    margin-left: 5px;
  }
`;

function InfoBanner({ text }) {
  return (
    <Container>
      <Icon type="chevron-left" size={10} /> <span>{text}</span>
    </Container>
  );
}

export default InfoBanner;
